const translations = {
    invalidEmail: 'Invalid Email',
    requiredErrorMessage: 'Email Address Is Required',
    tooLong: 'Email Address Is Too Long',
    tooShort: 'Email Address Is Too Short'
};

export default translations;
